// Перечисление на языке интерфейса: «8:03, 9:10 и 12:00» / «8:03, 9:10, and 12:00».
export const formatList = (values: readonly string[], locale: string): string =>
  new Intl.ListFormat(locale, { style: "long", type: "conjunction" }).format(values);
